import { FC, ReactNode, useContext, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

interface Props {
	handleClose: () => void;
	children: ReactNode | ReactNode[];
}

const HubspotFormModal: FC<Props> = ({ handleClose, children }) => {
	const { lang } = useContext(GlobalContext);
	const [modalRoot, setModalRoot] = useState<HTMLElement | null>(null);
	const textClose = translate(lang, {
		en: 'Close',
		ru: 'Закрыть',
		ua: 'Закрити',
	});

	useEffect(() => {
		const element = document.getElementById('modal-root');

		if (element) setModalRoot(element);

		document.body.style.overflow = 'hidden';

		return () => {
			document.body.style.overflow = 'auto';
		};
	}, []);

	if (!modalRoot) return null;

	return createPortal(
		<Wrapper>
			<Left>
				<Close onClick={handleClose}>
					<img alt="Close" src="/images/messaging-partners/close.svg" />

					<span>{textClose}</span>
				</Close>
			</Left>

			<Container>{children}</Container>
		</Wrapper>,
		modalRoot,
	);
};

export default HubspotFormModal;

const Wrapper = styled.div`
	z-index: 9002;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
	background: #f5f4f9fa;
	position: fixed;
	padding-bottom: 80px;
	padding-top: 59px;
	transition: 0.2s linear;

	&.visible {
		opacity: 1;
		visibility: visible;
	}
`;

const Container = styled.div`
	width: 600px;
	max-width: 95%;
	margin: 0 auto;
	position: relative;

	@media (min-width: 1500px) {
		width: 700px;
	}

	@media (min-width: 1700px) {
		width: 750px;
	}

	h2,
	h1 span {
		font-family: var(--font-sans) !important;

		font-weight: var(--font-bold);
		font-size: 42px !important;
		line-height: 50px;
		color: #7360f2;
		text-align: center;

		@media (max-width: 600px) {
			font-size: 28px !important;
			line-height: 32px;
		}
	}

	.subtitleModal {
		font-family: var(--font-sans);

		font-size: 16px;
		line-height: 25px;
		color: #776fa9;
		text-align: center;
		margin-top: 1rem;
	}

	form {
		margin-top: 60px;

		@media (max-width: 600px) {
			margin-top: 40px;
		}
	}
`;

const Left = styled.div`
	width: 90%;
	margin: 0 auto;
`;

const Close = styled.button`
	position: absolute;
	top: 5vw;
	left: 5vw;
	background: #ffffff;
	border-radius: 12px;
	display: flex;
	align-items: center;
	padding: 9px 9px;
	outline: none;
	padding-right: 20px;
	cursor: pointer;

	@media (max-width: 900px) {
		background: transparent;
		right: 15px;
		top: 15px;
		left: auto;
		color: #f5f4f9;
		padding: 0;

		span {
			display: none;
		}

		img {
			width: 28px;
			height: 28px;
		}
	}

	span {
		font-family: var(--font-sans);

		font-weight: var(--font-medium);
		font-size: 14px;
		line-height: 20px;
		color: #776fa9;
		margin-left: 3px;
	}
`;
